/**
 * Amenity Fragment
 *
 * Common pattern for amenity references used in nursery-search-block.
 */

/**
 * Field projection for an amenity reference
 * Can be interpolated into block queries
 */
export const amenityFields = `
  _id,
  _type,
  name
`
